// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $NotificationRelated = {
  canNotLoadInfo: "정보를 불러올 수 없습니다.",
  errorOccurredTrayAgain: "에러가 발생했습니다. 다시 시도해주세요",
};

const $DataCategory = {
  total: "전체 평균",
  memorize: "기억력",
  executive: "집행능력",
  calculation: "계산능력",
  language: "언어능력",
  attention: "주의력",
  visuoSpatial: "시공간능력",
};

const $Common = {
  serviceName: "알츠가드 A+T",
  all: "전체",
  cancel: "취소",
  deletion: "삭제",
  delete: "삭제하기",
  modification: "수정",
  modify: "수정하기",
  doneModification: "수정 완료",
  cancelModification: "수정 취소",
  confirmDelete: "삭제하면 복구할 수 없습니다. 계속하시겠습니까?",
  message: "메세지",
  greeting: "안녕하세요!",
  goodbye: "안녕히 가세요!",
  none: "없음",
  ok: "확인",
  or: "또는",
  close: "닫기",
  subtitle: "",
  // title: "",
  unknown: "모름",
  init: "초기화",
  search: "검색",
  index: "no.",
  isActivated: "활성 여부",
  deleteSelected: "선택 삭제",
  undefined: "-",
  general: "맞춤형",
  custom: "선택형",

  // Drawer
  dashboard: "Dashboard",
  userManagement: "사용자 관리",
  licenseManagement: "사용권 코드 관리",
  companyManagement: "기관 관리",
  adminManagement: "관리자 설정",
  notificationManagement: "푸시 알림",

  language: "언어",
  content: "",
  save: "저장하기",
  deleteSuccess: "삭제 완료",
  editSuccess: "수정 완료",
  inputSuccess: "입력 완료",
  registerSuccess: "등록 완료",
  inviteSuccess: "초대 완료",

  export: "내보내기",
  messageSelect: "{msg}개의 항목이 선택되었습니다.",
  messageSelectAll: "이 페이지에 있는 {msg}개의 항목이 모두 선택되었습니다.",
  messageSelectEn: "{msg} record{plural} selected",
  messageSelectAllEn: "All records selected",
  messageDelete: "선택하신 {msg}개의 항목을 삭제하시겠습니까?",
  messageDeleteUser: "선택하신 사용자를 삭제하시겠습니까?",
  hintNumber: "숫자만 입력",
  hintDate: "날짜 선택",
  hintInput: "입력",

  // Unit
  numbersPeople: "명",
  unitMin: "분",
  unitSec: "초",
  unitMinUnder: "분 미만",
  unitPoint: "점",
  unitScore: "점수",

  // 대시보드
  reexaminers: "재검사 대상자 명단",
  lbAlzA: "두뇌검사",
  lbAlzT: "두뇌훈련",

  // 사용자 관리
  company: "기관명",
  userName: "이름",
  reAssessOverDays: "재검사 경과일",
  reAssessDate: "재검사 기준일",
  userStatus: "사용자 상태",
  status: "상태",
  attended: "참여",
  breakaway: "이탈",
  userProfile: "사용자 상세보기",
  spendTimes: "소요 시간",
  totalScore: "총점",
  onDay: "당일",
  over1Day: "1일 경과",
  over2Days: "2일 경과",
  over3Days: "3일 경과",
  over4Days: "4일 경과",
  over5Days: "5일 경과",
  over6Days: "6일 경과",
  over7Days: "7일 이상 경과",
  result: "검사 결과",
  enterResult: "결과 입력하기",
  submitResult: "결과 입력",
  assessmentDate: "검사 날짜",
  resultSgdsK: "우울",
  resultCist: "CIST",

  // 사용권 코드 관리
  license: "사용권 코드",
  issued: "발급 수",
  registered: "등록 수",
  availableDays: "유효기간 (일)",
  issuedAt: "발급일",
  expireAt: "만료일",
  registerLicense: "사용권 코드 등록",
  register: "등록하기",

  // 기관 관리
  companyCode: "기관 코드 명",
  addCompany: "기관 추가",

  // 관리자 설정
  name: "이름",
  email: "이메일",
  role: "권한",
  invite: "초대하기",
  inviteAdmin: "관리자 초대",
  adminDetail: "관리자 상세보기",

  // 푸시 알림
  notifiedDate: "푸시 발송일",
  notifiedDateTime: "푸시 발송일시",
  notify: "푸시 알림 발송",
  notificationDetail: "푸시 알림 발송 내역",
  notificationTitle: "푸시 타이틀",
  notificationBody: "푸시 메시지 내용",

  // 날짜 관련
  weekdaysLong: "일요일 월요일 화요일 수요일 목요일 금요일 토요일",
  weekdaysShort: "일 월 화 수 목 금 토",
  today: "오늘",
  yesterday: "어제",
  weekly: "주간",
  daily: "일간",
  monthly: "월간",
  year: "년(4자)",
  month: "월",
  day: "일",
  second: "초",
  before: "이전",

  // 환자 관련
  displayName: "이름",
  patientCode: "이용권 번호",
  age: "나이",
  birthDt: "생년월일",
  gender: "성별",

  lastEvaluationDt: "마지막 평가",
  male: "남",
  female: "여",
  phone: "핸드폰 번호",
  address: "주소",
  firstOutbreakDt: "최초 발병일",
  recentVisitDt: "최근 방문일",
  diseaseType: "질병 타입",
  disabilityType: "장애 타입",
  authenticationNumber: "인증코드",

  hasNoData: "결과가 존재하지 않습니다.",
};

export const ko = {
  CommonDialog: {
    ...$Common,
  },
  AppBar: {
    ...$Common,
  },
  DrawerSetting: {
    ...$Common,
  },
  LanguageSet: {
    ...$Common,
  },
  DarkModeSet: {
    ...$Common,
  },
  DrawerMenuList: {
    ...$Common,
    patientManagement: "환자 관리",
    notice: "공지사항",
    profile: "프로필",
    logout: "로그아웃",
    userList: "유저 리스트",
    userAdd: "유저 추가",
  },
  LoginLayoutHeader: {
    ...$Common,
  },
  Dashboard: {
    ...$Common,
    ...$DataCategory,
    lbRangeDataT: "기간별 데이터 보기",
  },
  DashboardHeader: {
    ...$Common,
    title: $Common.dashboard,
    labelCompany: "기관 선택",
  },
  DashboardAData: {
    ...$Common,
    ...$DataCategory,
    lblLicenseRegister: "사용권 코드 등록 수",
    lbFirstDone: "1회차 검사 완료 수",
    lbReExaminers: "재검사 대상자",
    lbShowReExaminersList: "명단 보기",
    lbCompletionRate: "회차별 검사 완료율",
    lbAverageTimeA: "평균 소요시간",
    lbAScore: "인지영역별 평균 점수",
  },
  DashboardTData: {
    ...$Common,
    ...$DataCategory,
    lbAverageTimeT: "1인당 평균 사용 시간",
    lbUser: "두뇌훈련 사용자 수",
    lbCorrectAnswerRate: "두뇌훈련 정답률",
    lbGameRatio: "두뇌훈련 영역 비율",
  },
  TDataDialog: {
    ...$Common,
    ...$DataCategory,
    lbRangeDataTitle: "두뇌훈련 기간별 데이터",
  },
  ReExaminerList: {
    ...$Common,
  },
  ReExaminerHeader: {
    ...$Common,
  },
  ReExaminerTable: {
    ...$Common,
  },
  ReExaminerTableHeader: {
    ...$Common,
  },
  UserList: {
    ...$Common,
  },
  UserListHeader: {
    ...$Common,
  },
  UserTableHeader: {
    ...$Common,
  },
  UserTable: {
    ...$Common,
    userInfo: "사용자 정보",
    addUser: "사용자 추가",
  },
  UserProfile: {
    ...$Common,
  },
  UserInfo: {
    ...$Common,
    userInfo: "사용자 정보",
    birthDate: "생년월일(만 나이)",
    edu: "학력(교육 연수)",
    regDate: "가입 일시",
    sns: "가입 유형",
  },
  UserInfoDialog: {
    ...$Common,
    userInfo: "사용자 정보",
    birthDate: "생년월일(만 나이)",
    edu: "학력(교육 연수)",
    regDate: "가입 일시",
    sns: "가입 유형",
  },

  UserResult: {
    ...$Common,
    resultDate: "검사 날짜",
  },
  UserProfileHeader: {
    ...$Common,
    userDelete: "사용자 삭제",
  },
  UserAnTResults: {
    ...$Common,
  },
  UserAResult: {
    ...$Common,
    total: "전체 결과",
    detail: "상세 결과",
    round: "회차",
    date: "날짜",
    startTime: "시작 시간",
    endTime: "종료 시간",
    averageScore: "평균 점수",
    dropOut: "중도 이탈",
  },
  AResult: {
    ...$Common,
    totalCount: "총 문제 수",
    correctAnswers: "정답 수",
    averageReactionSpeed: "평균 반응 속도",
    question: "문제",
    isCorrect: "정답 여부",
    reactionSpeed: "반응 속도",
  },
  UserTResult: {
    ...$Common,
  },
  UserTResultTableHeader: {
    ...$Common,
    gameResult: "게임 결과",
  },
  UserTResultTable: {
    ...$Common,
    gameName: "게임명",
    playDate: "사용 날짜",
    startTime: "시작 시간",
    endTime: "종료 시간",
    playTime: "사용 시간",
    totalQuestions: "총 푼 문제 수",
    correctAnswers: "맞은 문제 수",
    correctRate: "정답률",
    level: "난이도",
  },
  UserAssessmentDialog: {
    ...$Common,
  },
  DatePicker: {
    ...$Common,
  },
  LicenseList: {
    ...$Common,
    title: "사용권 코드 관리",
  },
  LicenseTableHeader: {
    ...$Common,
  },
  LicenseTable: {
    ...$Common,
  },
  LicenseDetailDialog: {
    ...$Common,
    title: "사용권 코드 상세보기",
    rulesErrorMinAvailableDays: "1 이상의 숫자 입력",
    rulesErrorMaxAvailableDays: "9999 이하의 숫자 입력",
  },
  LicenseRegisterDialog: {
    ...$Common,
    hintIssuance: "발급 수  (Min : 1) 숫자만 입력",
    rulesErrorMinIssuance: "1 이상의 숫자 입력",
    rulesErrorMaxIssuance: "9999 이하의 숫자 입력",
    hintAvailableDays:
      "코드 유효기간 (단위 : 일, Min : 1, Max : 9999) 숫자만 입력",
    rulesErrorMinAvailableDays: "1 이상의 숫자 입력",
    rulesErrorMaxAvailableDays: "9999 이하의 숫자 입력",
  },
  CompanyList: {
    ...$Common,
  },
  CompanyTableHeader: {
    ...$Common,
  },
  CompanyTable: {
    ...$Common,
  },
  CompanyAddDialog: {
    ...$Common,
    addCompany: "기관 등록",
  },
  CompanyDetailDialog: {
    ...$Common,
    companyDetail: "기관 상세보기",
  },
  AdministratorList: {
    ...$Common,
  },
  AdministratorTableHeader: {
    ...$Common,
  },
  AdministratorTable: {
    ...$Common,
  },
  AdminInviteDialog: {
    ...$Common,
  },
  AdminDetailDialog: {
    ...$Common,
  },
  NotificationList: {
    ...$Common,
  },
  NotificationTableHeader: {
    ...$Common,
  },
  NotificationTable: {
    ...$Common,
  },
  NotificationRegisterDialog: {
    ...$Common,
  },
  NotificationDetailDialog: {
    ...$Common,
  },
  AddUserDialog: {
    ...$Common,
    addUser: "사용자 추가",
  },
};
